import { Component, ElementRef, EventEmitter, Input, SimpleChanges, OnChanges, OnInit, Output, ViewChild, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { TipoFrete, tiposFretes } from '../tipo-frete';

@Component({
    selector: 'sgt-tipo-frete-select',
    templateUrl: './tipo-frete-select.component.html',
    styleUrls: ['./tipo-frete-select.component.less'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => TipoFreteSelectComponent), multi: true },
    ]
})
export class TipoFreteSelectComponent implements OnInit, OnChanges {
    /** ID do tipo de frete */
    @Input() ngModel: number;
    /** Ao alterar o tipo de frete */
    @Output() ngModelChange = new EventEmitter<number>();

    /** Tipo de Frete */
    tipoFrete: TipoFrete;

    /** Tipos de fretes */
    tipos = tiposFretes;

    /** Nome do input */
    @Input() name: string;
    /* ID do input */
    @Input() id: string;
    /* Se o valor é obrigatório */
    @Input() required: any;
    /* Se deve desabilitar o input */
    @Input() disabled: boolean;
    /** Se pode selecionar nenhuma opção */
    @Input() canSelectNull = true;
    /** Label para a opção de selecionar a opção nula */
    @Input() nullLabel = 'NENHUM TIPO DE FRETE';

    @ViewChild('select') select: ElementRef;

    propagateChange: any = () => {};

    ngOnInit(): void {
        this.tipoFrete = this.getTipoFrete(this.ngModel);
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === 'ngModel' && !changes[propName].isFirstChange()) {
                this.tipoFrete = this.getTipoFrete(this.ngModel);
            }
        }
    }

    /** Obtem o tipo de frete através do ID */
    private getTipoFrete(idTipoFrete: number): TipoFrete {
        if (!idTipoFrete || !this.tipos) {
            return null;
        }
        return this.tipos.find(tipoFreteFilter => tipoFreteFilter.id === idTipoFrete);
    }

    /** Ao alterar o tipo de frete */
    onChange(idTipoFrete: number) {
        this.ngModel = idTipoFrete;
        this.propagateChange(this.ngModel);

        this.tipoFrete = this.getTipoFrete(this.ngModel);
    }

    /** Seta o focus no select */
    setFocus() {
        jQuery(this.select?.nativeElement).trigger('focus');
    }

    writeValue(value: number) {}

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {}
}
